"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.PaymentCompleted = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_1 = require("@atlaskit/button");
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var contexts_1 = require("../../contexts");
var PaymentCompleted = function (_a) {
    var onComplete = _a.onComplete;
    var _b = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), trelloIframe = _b.trelloIframe, appName = _b.appName;
    var _c = (0, react_1.useState)(false), isReloading = _c[0], setIsReloading = _c[1];
    var refetchSubscription = (0, react_1.useContext)(contexts_1.PaymentsContext).refetchSubscription;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: trelloIframe.localizeKey('welcome-to-the-tiny-power-ups-club') }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('your-reciept-and-invoice-will-be-emailed-to-you-shortly') }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('you-and-everyone-in-your-workspace-now-has-unlimited-access-to-all-of-our-power-ups') }, void 0), (0, jsx_runtime_1.jsx)("p", __assign({ style: { marginBottom: '8px' } }, { children: trelloIframe.localizeKey('if-you-ever-have-any-questions') }), void 0), (0, jsx_runtime_1.jsx)(button_1.LoadingButton, __assign({ isLoading: isReloading, appearance: "primary", shouldFitContainer: true, onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        setIsReloading(true);
                        refetchSubscription({
                            waitForStatus: 'active'
                        });
                        setIsReloading(false);
                        trelloIframe.confetti(e);
                        if (onComplete) {
                            onComplete();
                        }
                        return [2 /*return*/];
                    });
                }); } }, { children: trelloIframe.localizeKey('back-to-power-up', {
                    powerUpName: appName
                }) }), void 0)] }, void 0));
};
exports.PaymentCompleted = PaymentCompleted;
//# sourceMappingURL=PaymentCompleted.js.map